import React from 'react';
import GymDetailContainer from '../components/GymDetailContainer/GymDetailContainer';

const Detail = () => {
    return (
        <div>
            <GymDetailContainer />
        </div>
    );
}

export default Detail;
